// src/pages/ProvinciasPage.js
import React, { useState, useEffect } from 'react';
import api from '../utils/api';

export default function ProvinciasPage() {
  const [provincias, setProvincias] = useState([]);
  const [nombre, setNombre] = useState('');
  const [msg, setMsg] = useState('');

  const fetch = async () => {
    const res = await api.get('/provincias');
    setProvincias(res.data.data);
  };

  useEffect(() => { fetch(); }, []);

  const handleAdd = async (e) => {
    e.preventDefault();
    try {
      await api.post('/provincias', { nombre });
      setNombre(''); setMsg('✅ Provincia agregada');
      fetch();
    } catch (err) { setMsg('❌ ' + (err.response?.data?.message || 'Error')); }
  };

  const toggle = async (id) => {
    await api.patch(`/provincias/${id}/toggle`);
    fetch();
  };

  const s = {
    title: { fontSize: 22, fontWeight: 700, color: '#1a1a2e', marginBottom: 4 },
    card: { background: '#fff', borderRadius: 10, padding: 24, boxShadow: '0 2px 8px rgba(0,0,0,.08)', maxWidth: 500 },
    input: { padding: '8px 12px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 14, width: 220 },
    btn: { padding: '8px 18px', background: '#d4940a', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 600 },
    row: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 0', borderBottom: '1px solid #f0f0f0' },
  };

  return (
    <div>
      <div style={s.title}>📍 Maestro de Provincias</div>
      <div style={{ color: '#888', fontSize: 13, marginBottom: 20 }}>Gestión de orígenes de viaje</div>

      <div style={s.card}>
        <h3 style={{ marginTop: 0 }}>Agregar Provincia</h3>
        <form onSubmit={handleAdd} style={{ display: 'flex', gap: 10, marginBottom: 16 }}>
          <input style={s.input} value={nombre} onChange={e => setNombre(e.target.value)} placeholder="Nombre de provincia" required />
          <button type="submit" style={s.btn}>+ Agregar</button>
        </form>
        {msg && <div style={{ fontSize: 13, marginBottom: 12, color: msg.startsWith('✅') ? '#135200' : '#a8071a' }}>{msg}</div>}

        <h3>Provincias registradas</h3>
        {provincias.map(p => (
          <div key={p.id} style={s.row}>
            <div>
              <span style={{ fontWeight: 600 }}>{p.nombre}</span>
              {!p.activo && <span style={{ marginLeft: 8, fontSize: 11, color: '#999' }}>(inactiva)</span>}
            </div>
            <button
              onClick={() => toggle(p.id)}
              style={{ padding: '4px 12px', border: '1px solid', borderRadius: 6, cursor: 'pointer', fontSize: 12,
                background: p.activo ? '#fff1f0' : '#f6ffed',
                color: p.activo ? '#a8071a' : '#135200',
                borderColor: p.activo ? '#ffa39e' : '#b7eb8f' }}>
              {p.activo ? 'Desactivar' : 'Activar'}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
